/* eslint-disable react/prop-types */
import { Box, Grid, Typography } from "@mui/material";
import DatepickerField from "components/DatepickerField";
import FormField from "components/FormField";
import React from "react";
import SoftTypography from "components/SoftTypography";
import confirmDatePlugin from "flatpickr/dist/plugins/confirmDate/confirmDate";

export default function Footer({ formData }) {
  const { formFieldAppendix, values, errors, touched } = formData;
  const { releaseDateAppendix, representativeAppendix } = formFieldAppendix;
  const selectStyle = {
    fontSize: "0.875rem",
    color: "#495057",
    border: "0.0625rem solid #d2d6da",
    background: "#fff",
    padding: "0.5rem 0.75rem",
    width: "100%",
    borderRadius: "0.5rem",
    outline: "none",
  };
  return (
    <Box mt={5}>
      <Grid container spacing={1}>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <SoftTypography component="label" variant="caption" fontWeight="bold" mb={0.5}>
            Cơ quan thuế chuyển đến(Trường hợp chuyển địa điểm)
          </SoftTypography>
          <select style={selectStyle}>
            <option value="1">HCM-Cục thuế Thành phố Hồ Chí Minh</option>
            <option value="2">HN-Cục thuế Hà Nội</option>
          </select>
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            label={representativeAppendix.label}
            name={representativeAppendix.name}
            value={values.representativeAppendix}
            error={errors.representativeAppendix && touched.representativeAppendix}
            success={
              values.representativeAppendix?.toString().length > 0 && !errors.representativeAppendix
            }
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <DatepickerField
            label={releaseDateAppendix.label}
            name={releaseDateAppendix.name}
            error={errors.releaseDateAppendix && touched.releaseDateAppendix}
            success={
              values.releaseDateAppendix?.toString().length > 0 && !errors.releaseDateAppendix
            }
          />
        </Grid>
      </Grid>
    </Box>
  );
}
